module.exports = __webpack_public_path__ + "img/fail-omni.0d4d81bd.png";